interface StoredUser {
  accessToken: {
    token: string;
    expiration: string;
  };
  refreshToken: {
    token: string;
  };
  userId: string;
  name: string;
  surname: string;
  claims?: string[];
}

class TokenService {
  getLocalRefreshToken(): string {
    return localStorage.getItem("refreshToken") || this.getUser()?.refreshToken.token || "";
  }

  getLocalAccessToken(): string {
    return localStorage.getItem("accessToken") || this.getUser()?.accessToken.token || "";
  }

  getLocalClaims(): string[] {
    const user = this.getUser();
    return user?.claims ?? [];
  }

  updateLocalTokens(tokens: {
    accessToken: string;
    refreshToken: string;
  }): void {
    const user = this.getUser();
    if (user) {
      if (typeof user.accessToken === 'object') {
        user.accessToken.token = tokens.accessToken;
      }
      if (typeof user.refreshToken === 'object') {
        user.refreshToken.token = tokens.refreshToken;
      }
      localStorage.setItem("user", JSON.stringify(user));

      // Also store separately
      localStorage.setItem("accessToken", tokens.accessToken);
      localStorage.setItem("refreshToken", tokens.refreshToken);
    }
  }

  getUser(): StoredUser | null {
    const userStr = localStorage.getItem("user");
    return userStr ? JSON.parse(userStr) : null;
  }

  setUser(user: any): void {
    const accessToken = user.accessToken?.token || user.accessToken || "";
    const expiration = user.accessToken?.expirationDate || "";
    const refreshToken = user.refreshToken?.token || user.refreshToken || "";

    const userData: StoredUser = {
      accessToken: {
        token: accessToken,
        expiration: expiration,
      },
      refreshToken: {
        token: refreshToken,
      },
      userId: user.id || user.userId,
      name: user.firstName || user.name,
      surname: user.lastName || user.surname,
      claims: user.claims,
    };
    localStorage.setItem("user", JSON.stringify(userData));

    // Also store separately
    if (accessToken) localStorage.setItem("accessToken", accessToken);
    if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
  }

  removeUser(): void {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }
}

export default new TokenService();
